<template>
    <div class="t-container page">
        <div class="page-heading" role="heading">
            <h1 class="page-heading__header">
                Dangerous Goods
            </h1>
            <div class="t-flex t-mx-auto t-my-2">
                <button @click="showForm()" class="t-align-right t-bg-dodger-blue t-px-8 t-py-3">
                    <span class="t-text-base t-font-bold t-text-white">
                    <span class="t-text-sm">+</span>
                        Create Dangerous Good
                    </span>
                </button>
            </div>
        </div>

        <div class="t-mt-12 t-flex t-justify-center">
            <table class="t-w-full t-text-md bg-white t-shadow-md t-rounded t-mb-4" v-if="dangerousGoods.length >= 1">
                <tbody>
                    <tr class="t-border-b">
                        <th class="t-text-left t-p-3 t-px-5">Common Name</th>
                        <th class="t-text-left t-p-3 t-px-5">UN ID</th>
                        <th class="t-text-left t-p-3 t-px-5">Sizes</th>
                        <th class="t-p-3 t-px-5 t-flex t-justify-start">Actions</th>
                    </tr>
                    <tr 
                        class="t-border-b hover:t-bg-orange-100 t-bg-gray-100"
                        v-for="dangerousGood in dangerousGoods" :key="dangerousGood.id"
                    >
                        <td class="t-p-3 t-px-5">
                            {{ dangerousGood.name }}
                        </td>
                        <td class="t-p-3 t-px-5">
                           {{ dangerousGood.unDetails }}
                        </td>
                        <td class="t-p-3 t-px-5">
                            <li v-for="size in dangerousGood.sizes.data" :key="size.id">
                               {{ parseFloat(size.amount) }} {{ size.unit }} <i>({{ size.code }})</i>
                            </li>
                        </td>
                        <td class="t-p-3 t-px-5 t-flex t-justify-start">
                            <button @click="showForm(dangerousGood)" class="t-mr-3 t-text-sm t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-py-1 t-px-2 t-rounded focus:t-outline-none focus:t-shadow-outline">
                                Edit <i class="fa fa-pencil"></i>
                            </button>
                            <button @click="showConfirmDelete(dangerousGood)" class="t-text-sm t-bg-red-500 hover:t-bg-red-700 t-text-white t-py-1 t-px-2 t-rounded focus:t-outline-none focus:t-shadow-outline">
                                Delete <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <loading-alert :loading="loading" text="Loading dangerous products" color="warning"></loading-alert>
        </div>
        <div v-if="!loading && dangerousGoods.length == 0" class="t-bg-yellow-100 t-border t-border-yellow-400 t-text-yellow-700 t-px-4 t-py-3 t-rounded t-relative" role="alert">
            <span class="t-block sm:inline"> You don't have any dangerous goods yet.</span>
        </div>

        <dangerous-goods-form v-if="formShown" :showing="formShown" :product="product" @cancelled="formCancelled()" @submitted="formSubmitted()"></dangerous-goods-form>
		<confirm-delete v-if="showDeleteForm" :showing="showDeleteForm" :deleting="deleting" @confirmed="deleteConfirmed()" @cancelled="deleteCancelled()" title="Delete this dangerous good?" :text="confirmDeleteText"></confirm-delete>
    </div>
</template>

<script>
    import DangerousGoodsForm from './DangerousGoodsForm';
	import LoadingAlert from '../../utils/LoadingAlert';
	import ConfirmDelete from '../../utils/ConfirmDelete';

    export default {
        name: 'dangerous-goods',
        components: { DangerousGoodsForm, LoadingAlert, ConfirmDelete },

        data() {
            return {
                dangerousGoods: [],
                loading: null,
				product: null,
				formShown: false,
				deletingProduct: {},
				showDeleteForm: false,
				deleting: false
            }
        },

        mounted() {
            this.fetchDangerousGoods();
        },

        methods: {
			formCancelled() {
				this.product = null;
				this.formShown = false;
			},

			formSubmitted() {
				this.product = null;
				this.formShown = false;
				this.fetchDangerousGoods();
			},

			deleteCancelled() {
				this.showDeleteForm = false;
				this.deletingProduct = {};
			},

			deleteConfirmed() {
				this.deleting = true;

                axios.delete('/send-freight/dangerous-goods/' + this.deletingProduct.id)
					 .then(response => {
						for (var i = 0, l = this.dangerousGoods.length; i < l; i++) {
							if (this.dangerousGoods[i]['id'] == this.deletingProduct.id) {
								this.dangerousGoods.splice(i, 1);
								break;
							}
						}

						this.deleting = false;
						this.deletingProduct = null;
						this.showDeleteForm = false;
						this.$swal({
							title: "Dangerous good deleted!",
							type: "success",
							confirmButtonText: 'Okay',
						});
					 })
					 .catch(response => {
						this.deleting = false;
						this.deletingProduct = null;
						this.showDeleteForm = false;
						Event.$emit('serverError');
					 });
			},

			showForm(product = null) {
				if (product) {
					this.product = product;
				}

				this.formShown = true;
			},

            fetchDangerousGoods() {
                this.dangerousGoods = [];
                this.loading = true;

                axios.get('/send-freight/dangerous-goods', { headers: { Accept: 'application/json' } })
                    .then(response => {
						this.dangerousGoods = response.data.data;
                        this.loading = false;
                    })
                    .catch((error) => {
						Event.$emit('serverError');
                    });
            },

            showConfirmDelete(dangerousGood) {
				this.deletingProduct = dangerousGood;
				this.showDeleteForm = true;
            }
        },
		computed: {
			confirmDeleteText() {
				return "Are you sure you want to delete: "+this.deletingProduct.name+"?";
			}
		}
    }
</script>